const isObjectInArray = (array, item, ignore = []) => array.some((_item) => {
    let result = true;
    for (const key in _item) {
        if (!ignore.includes(key) && item[key] !== _item[key]) {
            result = false;
            break;
        }
    }
    return result;
});

export { isObjectInArray as default };
//# sourceMappingURL=isObjectInArray.js.map
